export function formatNumber(value, digits = 2) {
  if (value === null || value === undefined || value === '') return '-'
  const num = Number(value)
  if (Number.isNaN(num)) return value
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
}

export function formatPercent(value) {
  if (value === null || value === undefined) return '-'
  const prefix = value > 0 ? '+' : ''
  return `${prefix}${value}%`
}

export function delay(ms = 300) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function mockResponse(data, ms = 300) {
  return delay(ms).then(() => ({
    code: 200,
    msg: 'success',
    data
  }))
}
